// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"Dashboard_dashboardContainer__XAfqA","dashboardSelector":"Dashboard_dashboardSelector__3QNNe","signin":"Dashboard_signin__1-Ozr"};